var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoTabGIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "34px",
    viewBox: "0 0 42 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0251532,16.9124999 L20.0251532,20.2565975 L36.3842761,20.2565975 L36.3842761,22.1749512 L36.3842761,22.1749512 L36.3842761,22.2970738 L36.3842761,22.2970738 C36.3842761,25.9856157 35.6518352,28.3002056 34.2696435,29.1640387 C32.8874518,30.0278717 29.0681063,30.5029725 23.0164196,30.5029725 C15.0899314,30.5029725 10.171483,30.0277245 8.35803693,29.0859097 C6.54459084,28.1440948 5.66795702,25.6282234 5.66795702,21.543151 L5.66795702,16.8348123 L5.72460422,12.4354583 C5.72460422,8.40247188 6.54429657,5.84746244 8.15307706,4.84473342 C9.76185755,3.84200441 13.9215277,3.31820172 20.4920144,3.31820172 C27.537749,3.31820172 32.0155263,3.63645599 33.6984631,4.2686976 C35.3814,4.90093922 36.0923591,6.57490077 36.0923591,9.21701448 L36.0923591,10.0890871 L41.8562485,10.0890871 L41.8562485,8.75015327 C41.8562485,5.07029227 40.5788174,2.64608637 38.054265,1.59097709 C35.5297126,0.535867802 29.983731,0 21.4250011,0 C12.8662713,0 7.12430505,0.815278279 4.29900754,2.42847284 C1.47371002,4.0416674 -5.68434189e-14,7.35972198 -5.68434189e-14,12.2559529 L-5.68434189e-14,20.0385425 C-5.68434189e-14,25.8679073 1.30803535,29.6701851 3.85863073,31.3439995 C6.4092261,33.0178139 12.1948916,33.8728188 21.0807039,33.8728188 C30.4851691,33.8728188 36.3842761,33.1577399 38.6210313,31.7408242 C40.8577865,30.3239085 41.8605155,27.023363 42,21.7127983 L42,21.7127983 L42,16.9161783 L20.0251532,16.9124999 Z",
    id: "Path",
    fill: "#25477B",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoTabGIcon);
export default __webpack_public_path__ + "static/media/geoTabGIcon.7407a033ac2f73b1e7d16ae63fcfaba1.svg";
export { ForwardRef as ReactComponent };